import type { IconProps } from "@/types/IconProps";

export function Youtube(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      {...svgProps}
    >
      <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0m0 6.667q-.861 0-1.722.038l-.67.032-.64.038-.6.041-.548.042a2.534 2.534 0 0 0-2.329 2.283l-.026.283-.05.606A27 27 0 0 0 5.333 12q.005.987.082 1.97l.05.606.026.283a2.53 2.53 0 0 0 2.33 2.283l.548.042.6.04.64.039.67.032q.86.037 1.721.038.861 0 1.722-.038l.669-.032.641-.038.6-.041.547-.042a2.534 2.534 0 0 0 2.33-2.283l.026-.283.05-.606c.047-.629.082-1.315.082-1.97s-.035-1.341-.082-1.97l-.05-.606-.026-.283a2.53 2.53 0 0 0-2.33-2.283l-.548-.042-.6-.04-.64-.039-.67-.032A41 41 0 0 0 12 6.667m-.934 3.316a.4.4 0 0 1 .2.054l2.8 1.616a.4.4 0 0 1 .202.347.4.4 0 0 1-.202.347l-2.8 1.616a.4.4 0 0 1-.599-.347v-3.232a.4.4 0 0 1 .2-.347.4.4 0 0 1 .2-.054"></path>
    </svg>
  );
}
